// import { useState, useEffect } from "react";
// import { Typography, Button, IconButton } from "@material-tailwind/react";
// import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

// export function CarouselWithContent() {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [transition, setTransition] = useState(true);
//   const images = [
//     {
//       src: "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2560&q=80",
//       title: "The Beauty of Nature",
//       description: "It is not so much for its beauty that the forest makes a claim upon men's hearts, as for that subtle something, that quality of air that emanation from old trees, that so wonderfully changes and renews a weary spirit.",
//     },
//     {
//       src: "https://images.unsplash.com/photo-1493246507139-91e8fad9978e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2940&q=80",
//       title: "The Beauty of Mother",
//       description: "It is for its beauty that the forest makes a claim upon men's hearts, as for that subtle something, that quality of air that emanation from old trees, that so wonderfully changes and renews a weary spirit.",
//     },
//     {
//       src: "https://images.unsplash.com/photo-1518623489648-a173ef7824f3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2762&q=80",
//       title: "The Beauty of Father",
//       description: "It is not so much for its beauty that the forest makes a claim upon men's hearts, as for that subtle something, that quality of air that emanation that so wonderfully changes and renews a weary spirit.",
//     }
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setTransition(false);
//       setTimeout(() => {
//         setActiveIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
//         setTransition(true);
//       }, 300); // Transition duration
//     }, 2000); // Slide change interval

//     return () => clearInterval(interval);
//   }, []);

//   const handlePrev = () => {
//     setTransition(false);
//     setTimeout(() => {
//       setActiveIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
//       setTransition(true);
//     }, 300); // Transition duration
//   };

//   const handleNext = () => {
//     setTransition(false);
//     setTimeout(() => {
//       setActiveIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
//       setTransition(true);
//     }, 300); // Transition duration
//   };

//   return (
//     <div className="">
//       <div className=" relative  overflow-hidden  h-screen">
//         {images.map((image, index) => (
//           <div
//             key={index}
//             className={`absolute top-0 left-0 duration-500 ease-in-out w-full ${transition ? 'opacity-100' : 'opacity-90'} ${index === activeIndex ? 'z-2' : 'z-0'}`}
//             style={{ transform: `translateX(${index === activeIndex ? 0 : -100}%)` }}
//           >
//             <img
//               src={image.src}
//               alt={`image ${index + 1}`}
//               className="h-full w-full object-cover"
//             />
//             <div className="absolute inset-0 grid h-full w-full place-items-center bg-black/75">
//               <div className="w-3/4 text-center md:w-2/4">
//                 <Typography
//                   variant="h1"
//                   color="white"
//                   className="mb-4 text-3xl md:text-4xl lg:text-5xl"
//                 >
//                   {image.title}
//                 </Typography>
//                 <Typography
//                   variant="lead"
//                   color="white"
//                   className="mb-12 opacity-80"
//                 >
//                   {image.description}
//                 </Typography>
//                 <div className="flex justify-center gap-4 ">
//                   <Button size="lg" color="white" className="p-3">
//                     Explore
//                   </Button>
//                   <Button size="lg" color="white" variant="text">
//                     Gallery
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//       <IconButton
//         onClick={handlePrev}
//         className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-white/50 hover:bg-white/75 z-20"
//       >
//         <FaArrowLeft className="w-6 h-6 text-white z-20" />
//       </IconButton>
//       <IconButton
//         onClick={handleNext}
//         className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white/50 hover:bg-white/75"
//       >
//         <FaArrowRight className="w-6 h-6 text-white" />
//       </IconButton>
//     </div>
//   );
// }
// export default CarouselWithContent;

import React, { useState, useEffect } from "react";
// import { Typography, Button, IconButton } from "@material-tailwind/react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import img3 from "../sliderimage/image copy.png";
import img4 from "../sliderimage/image3.png";
import img5 from "../sliderimage/Startup-Punjab1.webp";
// import img6 from "../sliderimage/3.avif";
import logo1 from "../sliderimage/image.png";

export function CarouselWithContent() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [transition, setTransition] = useState(true);
  const images = [
    {
      src: logo1,
      title: "The Beauty of Innovation",
      description:
        "Innovation is the key to realizing the dream of 'New India.' It is the need of the hour, and we in India need to innovate and invest in technology to create a better future",
    },
    {
      src: img4,
      title: "The Beauty of Incubation",
      description:
        "The most powerful incubators are those that foster not just growth but also resilience in the startups they nurture.",
    },
    {
      src: img5,
      title: "The Beauty of Journey",
      description:
        "Your work is going to fill a large part of your life, and the only way to be truly satisfied is to do what you believe is great work. And the only way to do great work is to love what you do.",
    },
    {
      src: img3,
      title: "The Beauty of Success",
      description:
        "A self-reliant India will be a force multiplier for the global economy. We will make products in India, for the world",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setTransition(false);
      setTimeout(() => {
        setActiveIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
        setTransition(true);
      }, 300); // Transition duration
    }, 3500); // Slide change interval

    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setTransition(false);
    setTimeout(() => {
      setActiveIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
      setTransition(true);
    }, 300); // Transition duration
  };

  const handleNext = () => {
    setTransition(false);
    setTimeout(() => {
      setActiveIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
      setTransition(true);
    }, 300); // Transition duration
  };

  return (
    <div className="relative pt-20 flex items-center justify-center h-screen overflow-hidden">
      <div className="relative w-full h-full">
        {images.map((image, index) => (
          <div
            key={index}
            className={`absolute top-0 left-0 w-full h-full transition-transform duration-500 ease-in-out ${
              index === activeIndex
                ? "translate-x-0"
                : index > activeIndex
                ? "translate-x-full"
                : "-translate-x-full"
            }`}
          >
            <img
              src={image.src}
              alt={`image ${index + 1}`}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 grid h-full w-full place-items-center bg-black/60">
              <div className="w-3/4 text-white text-center md:w-2/4">
                <p
                  variant="h1"
                  color="white"
                  className="mb-4 text-3xl md:text-4xl lg:text-5xl"
                >
                  {image.title}
                </p>
                <p variant="lead" color="white" className="mb-12 opacity-80">
                  {image.description}
                </p>
                <div className="flex justify-center gap-4 ">
                  {/* <a href="#programs">
                    <Button size="lg" color="white" className="p-3">
                      Explore
                    </Button>
                  </a>
                  <Button size="lg" color="white" variant="text">
                    Gallery
                  </Button> */}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* <IconButton
        onClick={handlePrev}
        className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-white/50 hover:bg-white/75 z-20"
      >
        <FaArrowLeft className="w-6 h-6 text-white z-20" />
      </IconButton>
      <IconButton
        onClick={handleNext}
        className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white/50 hover:bg-white/75"
      >
        <FaArrowRight className="w-6 h-6 text-white" />
      </IconButton> */}
      <button
        className="absolute top-1/2 left-0 transform -translate-y-1/2 text-blue-600 bg-white p-2 rounded-full shadow-lg z-10"
        onClick={handlePrev}
      >
        <FaArrowLeft className="w-6 h-6 " />
      </button>
      <button
        className="absolute top-1/2 right-0 transform -translate-y-1/2 text-blue-600 bg-white p-2 rounded-full shadow-lg z-10"
        onClick={handleNext}
      >
        <FaArrowRight className="w-6 h-6 " />
      </button>
    </div>
  );
}

export default CarouselWithContent;
